import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import Carousel from '../../components/Carousel/Carousel'
import s from './styles'
import Chip from '@ntuctech/devex-tangram/Chip'

class TagCollection extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(slug) {
    this.props.onClickTag && this.props.onClickTag(slug)
  }

  render() {
    const { tagCollection, onClickTag } = this.props
    const selectedTag = tagCollection.find(tag => !!tag.checked) || ''
    return (
      <s.PromotionSection data-testid="promotions">
        <s.StyledPromotions>
          <Carousel infiniteScrolling hasMore>
            <li key={'all'} onClick={() => onClickTag()} data-testid="tagAll">
              <Chip selected={isEmpty(selectedTag)} label="All" />
            </li>
            {tagCollection.map(({ name, slug }) => {
              const tagTestId = name
                ? `-${name.replace(/\s/g, '-').toLowerCase()}`
                : ''
              return (
                <li
                  key={slug}
                  onClick={() => this.handleClick(slug)}
                  data-testid={`tagOption${tagTestId}`}
                >
                  <Chip selected={selectedTag?.slug === slug} label={name} />
                </li>
              )
            })}
          </Carousel>
        </s.StyledPromotions>
      </s.PromotionSection>
    );
  }
}

export default TagCollection
